/**
 * CSRF 토큰을 동일출처 요청에 자동으로 실어 보낸다 — jQuery·fetch·raw XHR 공통.
 *
 * 서버의 web 그룹(VerifyCsrfToken)이 POST/PUT/PATCH/DELETE 에서 X-CSRF-TOKEN 헤더(또는 _token)를
 * 검사한다. 호출부가 607곳(jQuery)+fetch+XHR 로 흩어져 있어 한 곳에서 못 넣으므로, 전송 계층 자체를
 * 감싼다. jQuery 는 내부적으로 XMLHttpRequest 를 쓰므로 XHR 패치가 jQuery 까지 덮는다 —
 * ajaxSetup 을 쓰지 않는 이유다(둘 다 쓰면 헤더가 두 번 붙어 "tok, tok" 이 되고 검증이 깨진다).
 *
 * 반드시 다른 스크립트가 요청을 쏘기 전에 설치돼야 한다 → app.js 가 평가 시점에 동기로 install() 한다.
 * 동일출처 요청에만 넣는다(카카오맵·이미지서버 같은 외부로는 토큰을 흘리지 않는다).
 */
export default class Csrf {
    static token() {
        const m = document.querySelector('meta[name="csrf-token"]');
        return m ? (m.getAttribute('content') || '') : '';
    }

    static sameOrigin(url) {
        try {
            return new URL(url, window.location.href).origin === window.location.origin;
        } catch (e) {
            return true; // 상대경로 등 파싱 불가 — 동일출처로 본다
        }
    }

    static install() {
        const token = Csrf.token();
        if (!token) return; // 토큰 없는 페이지(외부/정적)에서는 아무것도 하지 않는다

        // fetch
        if (typeof window.fetch === 'function' && !window.fetch.__csrfWrapped) {
            const orig = window.fetch;
            const wrapped = function (input, init) {
                init = init || {};
                const url = (typeof input === 'string') ? input : (input && input.url) || '';
                if (Csrf.sameOrigin(url)) {
                    const headers = new Headers(
                        init.headers || (typeof input !== 'string' && input && input.headers) || {}
                    );
                    if (!headers.has('X-CSRF-TOKEN')) headers.set('X-CSRF-TOKEN', token);
                    init.headers = headers;
                }
                return orig.call(this, input, init);
            };
            wrapped.__csrfWrapped = true;
            window.fetch = wrapped;
        }

        // XMLHttpRequest (jQuery $.ajax 포함)
        const XHR = window.XMLHttpRequest;
        if (XHR && !XHR.prototype.__csrfWrapped) {
            const origOpen = XHR.prototype.open;
            const origSend = XHR.prototype.send;
            XHR.prototype.open = function (method, url) {
                this.__csrfSameOrigin = Csrf.sameOrigin(url);
                return origOpen.apply(this, arguments);
            };
            XHR.prototype.send = function (body) {
                if (this.__csrfSameOrigin) {
                    try { this.setRequestHeader('X-CSRF-TOKEN', token); } catch (e) { /* open 전 호출 등 */ }
                }
                return origSend.apply(this, arguments);
            };
            XHR.prototype.__csrfWrapped = true;
        }
    }
}
